import type { CustomerResolvedOrder } from "../../data/customerData";

const toneMap: Record<CustomerResolvedOrder["stage"], string> = {
  accepted: "border-sky-300/20 bg-sky-300/10 text-sky-100",
  kitchen: "border-orange-300/20 bg-orange-300/10 text-orange-100",
  packing: "border-amber-300/20 bg-amber-300/10 text-amber-100",
  courier: "border-teal-300/20 bg-teal-300/10 text-teal-100",
  ready: "border-emerald-300/20 bg-emerald-300/10 text-emerald-100",
  completed: "border-stone-300/18 bg-stone-300/10 text-stone-200"
};

interface CustomerOrderStatusPillProps {
  order: CustomerResolvedOrder;
  dark?: boolean;
}

export function CustomerOrderStatusPill({ order, dark = false }: CustomerOrderStatusPillProps) {
  return (
    <span
      className={[
        "inline-flex items-center rounded-full border px-3 py-1.5 text-[0.72rem] uppercase tracking-[0.16em]",
        dark ? toneMap[order.stage] : "border-teal-900/10 bg-teal-900/[0.05] text-teal-900"
      ].join(" ")}
    >
      {dark ? order.shortStatus : order.status}
    </span>
  );
}
